import axios from 'axios';
import { handleAuthError } from '../funciones/authHelper';

/**
 * Origen "intervenciones" para NotificacionesPopover.
 *
 * El módulo de Intervenciones tiene su propia tabla `notificaciones` y sus
 * endpoints bajo /api/citas-tecnicas/notificaciones (Fase 3 base). El popover
 * global espera items con forma { Id, titulo, mensaje, createdAt, leida, link,
 * tipo }, así que aquí MAPEAMOS la respuesta del módulo a esa forma (igual que
 * hace el origen Inventario). El backend de Intervenciones NO se toca.
 */

const BASE = `${process.env.REACT_APP_API_URL}/api/citas-tecnicas/notificaciones`;
const auth = () => ({ headers: { Authorization: `Bearer ${localStorage.getItem('token')}` } });

// Mapea un item del módulo (id, cuerpo, link_url, created_at) a la forma del popover.
function mapItem(r) {
  return {
    Id: r.id,
    titulo: r.titulo,
    mensaje: r.cuerpo,
    link: r.link_url,
    tipo: r.tipo,
    leida: !!r.leida,
    createdAt: r.created_at,
  };
}

// GET /api/citas-tecnicas/notificaciones → devuelve array de items (forma popover)
export const getNotifIntervenciones = async () => {
  try {
    const r = await axios.get(BASE, auth());
    const data = Array.isArray(r.data?.data) ? r.data.data : [];
    return data.map(mapItem);
  } catch (error) {
    handleAuthError(error);
    throw error;
  }
};

// GET /api/citas-tecnicas/notificaciones/no-leidas-count → { count } → { no_leidas }
export const getContadorIntervenciones = async () => {
  try {
    const r = await axios.get(`${BASE}/no-leidas-count`, auth());
    return { no_leidas: Number(r.data?.count || 0) };
  } catch (error) {
    handleAuthError(error);
    throw error;
  }
};

// POST /api/citas-tecnicas/notificaciones/:id/leida
export const marcarLeidaIntervenciones = async (id) => {
  try {
    const r = await axios.post(`${BASE}/${id}/leida`, {}, auth());
    return r.data;
  } catch (error) {
    handleAuthError(error);
    throw error;
  }
};

// POST /api/citas-tecnicas/notificaciones/leer-todas
export const marcarTodasIntervenciones = async () => {
  try {
    const r = await axios.post(`${BASE}/leer-todas`, {}, auth());
    return r.data;
  } catch (error) {
    handleAuthError(error);
    throw error;
  }
};
